/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs */

const en__field_enum_tuda_mindestens_1_mal_pro_woche25 = /** @type {(inputs: _Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minimum once a week`)
};

const de__field_enum_tuda_mindestens_1_mal_pro_woche25 = /** @type {(inputs: _Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mindestens einmal pro Woche`)
};

/**
* | output |
* | --- |
* | "minimum once a week" |
*
* @param {_Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_mindestens_1_mal_pro_woche25 = /** @type {((inputs?: _Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Mindestens_1_Mal_Pro_Woche25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_mindestens_1_mal_pro_woche25(inputs)
	return de__field_enum_tuda_mindestens_1_mal_pro_woche25(inputs)
});
export { _field_enum_tuda_mindestens_1_mal_pro_woche25 as "_field_enum_TUDA_MINDESTENS_1_MAL_PRO_WOCHE" }